import { FirestoreGenerationStatusCode } from "reedy-data/models";
import { TFunction } from "i18next";

export function generationErrorMessage(
  t: TFunction,
  code?: FirestoreGenerationStatusCode | null,
) {
  switch (code) {
    // biome-ignore lint/nursery/noDanglingUnderscore: generated enum member name from reedy-data
    case FirestoreGenerationStatusCode._402:
      return t(`general:errors.message.GENERATION_LIMIT_REACHED`);
    // biome-ignore lint/nursery/noDanglingUnderscore: generated enum member name from reedy-data
    case FirestoreGenerationStatusCode._422:
      return t(`general:errors.message.GENERATION_TRUNCATED`);
    // biome-ignore lint/nursery/noDanglingUnderscore: generated enum member name from reedy-data
    case FirestoreGenerationStatusCode._451:
      return t(`general:errors.message.GENERATION_SAFETY_ERROR`);
    default:
      return null;
  }
}

export const getErrorMessage = (e: unknown): string => {
  if (!e) {
    return "An unknown error occurred";
  }

  if (typeof e === "string") {
    return e;
  }
  if (typeof e !== "object") {
    return "An unknown error occurred";
  }
  if ("message" in e && typeof e.message === "string") {
    return e.message;
  }

  if ("data" in e) {
    return getErrorMessage(e.data);
  }

  if ("toString" in e && typeof e.toString === "function") {
    return e.toString();
  }

  return "An unknown error occurred";
};
